// https://medium.com/@dan_abramov/mixins-are-dead-long-live-higher-order-components-94a0d2f9e750

// Returns a component which's state changes on window resize
import React, { PureComponent } from 'react';
import debounce from 'lodash.debounce';

import {getOrientation} from '../../helpers/orientation.helper';

export const reRenderOnResize = (Component) => {
  return class ReRenderOnReize extends PureComponent {
    constructor(props) {
      super(props);
      let width = 0;
      if (typeof window !== 'undefined') {
        width = window.innerWidth;
      }
      this.state = {
        windowWidth: width,
        orientation: getOrientation()
      };
      this.handleResize = this.handleResize.bind(this);
    }
    componentDidMount() {
      this.debounceHandleResize = debounce(this.handleResize, 300);
      window.addEventListener('resize', this.debounceHandleResize);
    }
    componentWillUnmount() {
      window.removeEventListener('resize', this.debounceHandleResize);
      this.debounceHandleResize.cancel();
    }
    handleResize() {
      this.setState({windowWidth: window.innerWidth, orientation: getOrientation()});
    }
    render() {
      return (
        <Component
          {...this.props}
          resizeProps={{
            windowWidth: this.state.windowWidth,
            orientation: this.state.orientation
          }}
        />
      );
    }
  };
};



// WEBPACK FOOTER //
// ./containers/ResizeHandler/ResizeHandler.js